module.exports = __webpack_public_path__ + "static/img/voice-2.718d70c9.png";